import { render, staticRenderFns } from "./s_itsup.vue?vue&type=template&id=03fff472"
import script from "./s_itsup.vue?vue&type=script&lang=js"
export * from "./s_itsup.vue?vue&type=script&lang=js"
import style0 from "./s_itsup.vue?vue&type=style&index=0&id=03fff472&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports